import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouteErrorDisplay } from '@/components/RouteErrorDisplay'
import { requireAnyPermission } from '@/lib/auth/route-guards'
import type { RouterAuthContext } from '@/lib/auth/router-context'

export const Route = createFileRoute('/app/members')({
  // Permission guard: requires member viewing permission
  beforeLoad: async ({ context, location }) => {
    await requireAnyPermission(
      context as RouterAuthContext,
      ['members:view-list', 'members:view-details'],
      { currentPath: location.pathname }
    )
  },

  component: lazyRouteComponent(() => import('./-members')),
  errorComponent: ({ error }) => (
    <QueryErrorResetBoundary>
      {({ reset }) => <RouteErrorDisplay error={error} reset={reset} />}
    </QueryErrorResetBoundary>
  ),
})
